import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDocumentCameraIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 52,
	height: 52,
	viewBox: "0 0 52 52",
	fill: "white",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 26,
			cy: 26,
			r: 26
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.7602 36H31.2402C34.0002 36 35.1002 34.31 35.2302 32.25L35.7502 23.99C35.8902 21.83 34.1702 20 32.0002 20C31.3902 20 30.8302 19.65 30.5502 19.11L29.8302 17.66C29.3702 16.75 28.1702 16 27.1502 16H24.8602C23.8302 16 22.6302 16.75 22.1702 17.66L21.4502 19.11C21.1702 19.65 20.6102 20 20.0002 20C17.8302 20 16.1102 21.83 16.2502 23.99L16.7702 32.25C16.8902 34.31 18.0002 36 20.7602 36Z",
			stroke: "#787878",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.5 22H27.5",
			stroke: "#787878",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26 32C27.79 32 29.25 30.54 29.25 28.75C29.25 26.96 27.79 25.5 26 25.5C24.21 25.5 22.75 26.96 22.75 28.75C22.75 30.54 24.21 32 26 32Z",
			stroke: "#787878",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgDocumentCameraIcon;
